import { Epic, ofType } from 'redux-observable';
import { mergeMap } from 'rxjs/operators';
import { actions } from '.';
import { callApi } from 'Data/Helpers/rxjsHelpers';
import webApi from 'Lib/WebApi';
import { of } from 'rxjs';

export const init: Epic = (action$) =>
  action$.pipe(
    ofType(actions.init.toString()),
    mergeMap(({ payload: { userId = null } }) =>
      callApi(webApi.ags.workOrderList.get({ userId })).pipe(
        mergeMap((workOrder) => of(actions.initResolve({ workOrder })))
      )
    )
  );
